// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spacer_wrapper__aE93x"};